import React from 'react';
import { useFillsGraphConfigurationSelector } from './store/configuration/selectors';
import FillsChartsContainer from './FillsChartsContainer';
import {
    calculateFillsGraphTimeDomain,
    useFillsGraphData,
} from './fillsGraphData';
import FillsGraphToolbar from './toolbar/FillsGraphToolbar';
import './FillsGraph.scss';
import { useDispatchUpdateFillsGraphConfiguration } from './store/configuration/dispatcher';
import { XAxisContextProvider } from 'utils/components/TimeSeriesChart/XAxisContext';
import styleConstants from 'styles/variables.module.scss';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { useFillsGraphPortfolioData } from 'widgets/fillsGraph/fillsGraphPortfolioData';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useWidgetContext } from 'widgets/WidgetContext';
import { FillsChartType } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';

const padding = 2 * parseInt(styleConstants.spaceAround);
const toolbarHeight = parseInt(styleConstants.toolbarHeight);
const borderWidth = 2 * parseInt(styleConstants.layoutBorderWidth);

export default function FillsGraph() {
    const { widgetKey, width, height } = useWidgetContext();

    useWidgetStream();

    const config = useFillsGraphConfigurationSelector();
    const updateConfig = useDispatchUpdateFillsGraphConfiguration();

    const fillsGraphPortfolioData = useFillsGraphPortfolioData();
    const fillsGraphData = useFillsGraphData(fillsGraphPortfolioData);

    const { breaksInTrading, rangeLabels } = fillsGraphData;
    const timeDomain = calculateFillsGraphTimeDomain(fillsGraphData);

    const chartWidth = width ? width - padding - borderWidth : 0;
    const toolbarConsumedHeight = config.hideToolbar ? 0 : toolbarHeight;
    const containerHeight =
        height - toolbarConsumedHeight - padding - borderWidth;

    return (
        <div className="FillsGraph" data-widget-id={widgetKey}>
            <XAxisContextProvider
                timeSeriesChartWidth={chartWidth}
                startTime={timeDomain[0]}
                endTime={timeDomain[1]}
                breaks={breaksInTrading}
                rangeLabels={rangeLabels}
                timeLineLabels={[]}
            >
                <WidgetToolbarShowHidePanel mustShow={!fillsGraphPortfolioData}>
                    <FillsGraphToolbar
                        avgExecAndVwapDecimals={
                            config[FillsChartType.OrderFills]
                                .avgExecAndVwapDecimals
                        }
                        fillsGraphData={fillsGraphData}
                        fillsGraphPortfolioData={fillsGraphPortfolioData}
                        fillsGraphConfiguration={config}
                        onFillsGraphConfigurationChange={updateConfig}
                    />
                </WidgetToolbarShowHidePanel>
                {fillsGraphPortfolioData && (
                    <FillsChartsContainer
                        fillsGraphData={fillsGraphData}
                        fillsGraphPortfolioData={fillsGraphPortfolioData}
                        config={config}
                        width={chartWidth}
                        height={height ? containerHeight : 0}
                    />
                )}
            </XAxisContextProvider>
        </div>
    );
}
